import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { verifyEmail, selectAuthStatus, selectAuthError } from '../features/auth/authSlice';
import SEO from './SEO';
import './VerifyEmailPage.css';

const VerifyEmailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);
  const [verificationStatus, setVerificationStatus] = useState('pending'); // pending, success, error

  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      dispatch(verifyEmail({ token }))
        .unwrap()
        .then((result) => {
          setVerificationStatus('success');
          // Redirect after a short delay
          setTimeout(() => {
            navigate('/dashboard');
          }, 2000);
        })
        .catch(() => {
          setVerificationStatus('error');
        });
    } else {
      setVerificationStatus('error');
    }
  }, [token, dispatch, navigate]);

  return (
    <>
      <SEO
        title="Verify Email - MyCleanStudio"
        description="Verify your email address for MyCleanStudio"
        url="/verify-email"
      />
      <div className="verify-email-page">
        <div className="verify-email-container">
          {status === 'loading' && verificationStatus === 'pending' && (
            <div className="verify-status verifying">
              <div className="verify-icon">
                <Loader size={48} className="spinner" />
              </div>
              <h2>Verifying your email...</h2>
              <p>Please wait while we verify your email address.</p>
            </div>
          )}

          {verificationStatus === 'success' && (
            <div className="verify-status success">
              <div className="verify-icon success-icon">
                <CheckCircle size={48} />
              </div>
              <h2>Email Verified!</h2>
              <p>Your email has been verified successfully.</p>
              <p className="redirect-message">Redirecting you to the app...</p>
            </div>
          )}

          {verificationStatus === 'error' && (
            <div className="verify-status error">
              <div className="verify-icon error-icon">
                <XCircle size={48} />
              </div>
              <h2>Verification Failed</h2>
              <p>{error || 'The verification link is invalid or has expired.'}</p>
              <div className="verify-actions">
                <button
                  onClick={() => navigate('/login')}
                  className="primary-btn"
                >
                  Go to Login
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VerifyEmailPage;
